import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axiosInstance from "../../../Shared/axiosInstance";

export default function SupplierOpenBalanceDetails() {
  const { id } = useParams();
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const { data } = await axiosInstance.get(`/SupplierOpeningBalance/${id}`);
        setBalance(data.data);
      } catch (err) {
        console.error("Error fetching opening balance details:", err);
        Swal.fire("خطأ", "فشل تحميل تفاصيل الرصيد الافتتاحي", "error");
      } finally {
        setLoading(false);
      }
    };
    
    fetchDetails();
  }, [id]);

  if (loading) {
    return (
      <div className="container mt-5 pt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">جاري التحميل...</span>
        </div>
        <p className="mt-3">جاري تحميل تفاصيل الرصيد الافتتاحي...</p>
      </div>
    );
  }

  if (!balance) {
    return (
      <div className="container mt-5 pt-5 text-center">
        <p>لم يتم العثور على البيانات</p>
      </div>
    );
  }

  return (
    <div className="mt-5 pt-5" dir="rtl">
      {/* Action Buttons */}
      <div className="container mb-3" style={{ maxWidth: "900px" }}>
        <div className="d-flex gap-2">
          {/* زر إضافة دفعة */}
          <button
            style={{
              background: "#22c55e",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: "6px",
              border: "none",
              fontWeight: "600",
              fontSize: "16px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              whiteSpace: "nowrap",
              boxShadow: "0 2px 8px rgba(34, 197, 94, 0.3)",
            }}
            onClick={() => navigate(`/supplier-opening-balance/${id}/add-payment`)}
          >
            💰 إضافة دفعة
          </button>

          {/* زر الرجوع */}
          <button
            className="btn btn-outline-secondary"
            onClick={() => window.history.back()}
          >
            ← رجوع
          </button>
        </div>
      </div>

      {/* Balance Details Content */}
      <div className="container mb-5" style={{ maxWidth: "900px" }}>
        <div
          style={{
            background: "#ffffff",
            border: "2px solid #93c5fd",
            borderRadius: "8px",
            padding: "40px",
            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
          }}
        >
          {/* Header */}
          <div
            style={{
              borderBottom: "3px solid #60a5fa",
              paddingBottom: "20px",
              marginBottom: "30px",
            }}
          >
            <h3
              style={{
                color: "#2563eb",
                fontSize: "32px",
                fontWeight: "700",
                marginBottom: "5px",
              }}
            >
              رصيد افتتاحي للمورد
            </h3>

            <div style={{ color: "#64748b", fontSize: "16px" }}>
              رقم السجل: <strong>{balance.id}</strong>
            </div>

            <div style={{ color: "#64748b", fontSize: "16px" }}>
              التاريخ:{" "}
              {new Date(balance.balanceDate).toLocaleDateString("ar-EG")}
            </div>
          </div>

          {/* Supplier Info */}
          <div style={{ marginBottom: "30px" }}>
            <div className="row">
              <div className="col-md-6">
                <div
                  style={{
                    color: "#64748b",
                    fontSize: "14px",
                    marginBottom: "4px",
                  }}
                >
                  المورد
                </div>
                <div
                  style={{
                    color: "#000",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {balance.supplierName}
                </div>
                {balance.supplierDetails && (
                  <div
                    style={{
                      color: "#475569",
                      fontSize: "16px",
                      fontWeight: "500",
                      marginTop: "4px",
                    }}
                  >
                    {balance.supplierDetails}
                  </div>
                )}
              </div>

              <div className="col-md-6 text-end">
                <span
                  style={{
                    background:
                      balance.paymentStatus === "Paid"
                        ? "#dcfce7"
                        : balance.paymentStatus === "PartiallyPaid"
                        ? "#fef3c7"
                        : "#fee2e2",
                    color:
                      balance.paymentStatus === "Paid"
                        ? "#15803d"
                        : balance.paymentStatus === "PartiallyPaid"
                        ? "#b45309"
                        : "#b91c1c",
                    padding: "8px 18px",
                    borderRadius: "6px",
                    fontSize: "16px",
                    fontWeight: "600",
                    border:
                      balance.paymentStatus === "Paid"
                        ? "1px solid #86efac"
                        : balance.paymentStatus === "PartiallyPaid"
                        ? "1px solid #fcd34d"
                        : "1px solid #fca5a5",
                    display: "inline-block",
                  }}
                >
                  {balance.paymentStatus === "Paid"
                    ? "✓ مدفوعة"
                    : balance.paymentStatus === "PartiallyPaid"
                    ? "⊙ مدفوعة جزئياً"
                    : "✗ غير مدفوعة"}
                </span>
              </div>
            </div>
          </div>

          {/* Notes Section */}
          {balance.notes && (
            <div style={{ marginBottom: "30px" }}>
              <h5
                style={{
                  color: "#2563eb",
                  fontSize: "18px",
                  fontWeight: "600",
                  marginBottom: "12px",
                }}
              >
                ملاحظات
              </h5>
              <div
                style={{
                  background: "#f8fafc",
                  padding: "15px",
                  borderRadius: "6px",
                  border: "1px solid #e2e8f0",
                  color: "#475569",
                  fontSize: "16px",
                  lineHeight: "1.6",
                }}
              >
                {balance.notes}
              </div>
            </div>
          )}

          {/* Payments Table */}
          {balance.payments && balance.payments.length > 0 && (
            <div style={{ marginBottom: "25px" }}>
              <h5
                style={{
                  color: "#2563eb",
                  fontSize: "18px",
                  fontWeight: "600",
                  marginBottom: "12px",
                }}
              >
                سجل الدفعات
              </h5>

              <div className="table-responsive">
                <table
                  className="table mb-0"
                  style={{ border: "1px solid #dbeafe" }}
                >
                  <thead>
                    <tr style={{ background: "#eff6ff" }}>
                      <th
                        style={{
                          color: "#1e40af",
                          fontSize: "15px",
                          padding: "10px",
                          fontWeight: "600",
                          border: "1px solid #bfdbfe",
                          textAlign: "center",
                        }}
                      >
                        #
                      </th>
                      <th
                        style={{
                          color: "#1e40af",
                          fontSize: "15px",
                          padding: "10px",
                          fontWeight: "600",
                          border: "1px solid #bfdbfe",
                          textAlign: "center",
                        }}
                      >
                        المبلغ
                      </th>
                      <th
                        style={{
                          color: "#1e40af",
                          fontSize: "15px",
                          padding: "10px",
                          fontWeight: "600",
                          border: "1px solid #bfdbfe",
                          textAlign: "center",
                        }}
                      >
                        التاريخ
                      </th>
                      <th
                        style={{
                          color: "#1e40af",
                          fontSize: "15px",
                          padding: "10px",
                          fontWeight: "600",
                          border: "1px solid #bfdbfe",
                          textAlign: "center",
                        }}
                      >
                        طريقة الدفع
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {balance.payments.map((p, index) => (
                      <tr
                        key={index}
                        style={{
                          background: index % 2 === 0 ? "#f8fafc" : "#ffffff",
                        }}
                      >
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #e0e7ff",
                            textAlign: "center",
                            fontSize: "16px",
                            color: "#64748b",
                            fontWeight: "600",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #e0e7ff",
                            textAlign: "center",
                            fontSize: "17px",
                            color: "#2563eb",
                            fontWeight: "700",
                          }}
                        >
                          {p.amount.toLocaleString()} جنيه
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #e0e7ff",
                            textAlign: "center",
                            fontSize: "16px",
                            color: "#475569",
                          }}
                        >
                          {new Date(p.date).toLocaleDateString("ar-EG")}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #e0e7ff",
                            textAlign: "center",
                            fontSize: "16px",
                            color: "#000",
                            fontWeight: "500",
                          }}
                        >
                          {p.method === "Cash" ? "كاش" : p.method}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* No Payments Message */}
          {(!balance.payments || balance.payments.length === 0) && (
            <div
              style={{
                background: "#fef3c7",
                padding: "20px",
                borderRadius: "6px",
                border: "1px solid #fcd34d",
                textAlign: "center",
                marginBottom: "25px",
              }}
            >
              <p
                style={{
                  color: "#b45309",
                  fontSize: "16px",
                  fontWeight: "600",
                  margin: 0,
                }}
              >
                ⚠️ لم يتم إضافة أي دفعات حتى الآن
              </p>
            </div>
          )}

          {/* Total Summary */}
          <div
            style={{
              borderTop: "2px solid #93c5fd",
              paddingTop: "20px",
              marginTop: "10px",
              background: "#f8fafc",
              padding: "20px",
              borderRadius: "6px",
            }}
          >
            <div className="row mb-2">
              <div className="col-6">
                <span style={{ color: "#64748b", fontSize: "17px" }}>
                  إجمالي المبلغ:
                </span>
              </div>
              <div className="col-6 text-end">
                <span
                  style={{
                    color: "#1e40af",
                    fontSize: "22px",
                    fontWeight: "700",
                  }}
                >
                  {balance.totalAmount.toLocaleString()} جنيه
                </span>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-6">
                <span style={{ color: "#64748b", fontSize: "17px" }}>
                  إجمالي المدفوع:
                </span>
              </div>
              <div className="col-6 text-end">
                <span
                  style={{
                    color: "#2563eb",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  {balance.paidAmount.toLocaleString()} جنيه
                </span>
              </div>
            </div>

            <div
              className="row"
              style={{
                borderTop: "2px solid #cbd5e1",
                paddingTop: "12px",
                marginTop: "8px",
              }}
            >
              <div className="col-6">
                <span
                  style={{
                    color: "#64748b",
                    fontSize: "17px",
                    fontWeight: "600",
                  }}
                >
                  المتبقي:
                </span>
              </div>

              <div className="col-6 text-end">
                <span
                  style={{
                    color:
                      balance.remainingAmount > 0 ? "#dc2626" : "#16a34a",
                    fontSize: "24px",
                    fontWeight: "700",
                  }}
                >
                  {balance.remainingAmount.toLocaleString()} جنيه
                </span>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div
            style={{
              marginTop: "30px",
              paddingTop: "20px",
              borderTop: "1px solid #e2e8f0",
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "13px",
            }}
          >
            <p style={{ margin: 0 }}>
              تم عرض البيانات بتاريخ {new Date().toLocaleString("ar-EG")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}